import { Box, Link } from "@mui/material";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import {
  icons,
  logos,
} from "../../../../../stack/environment/icons/iconExport";

const JiraTicket = ({ ticket }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();

  const handleJiraClick = (e) => {
    e.stopPropagation();
    trackEvent(`User clicked on Jira ticket for control: ${ticket.control_id}`);
  };

  return (
    <Box>
      <Link
        variant="caption"
        href={ticket?.jira_details?.jira_link}
        target="_blank"
        onClick={handleJiraClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: "1px solid " + colors.grey_300,
          borderRadius: "14px",
          padding: "2px 6px",
        }}
      >
        <SvgToIcon IconLogo={logos.JiraLogo} width={16} height={16} />
        <SvgToIcon IconLogo={icons.ExternalLinkIcon} width={14} />
      </Link>
    </Box>
  );
};

export default JiraTicket;
